// extracted by mini-css-extract-plugin
module.exports = {"disclaimerModal":"DisclaimerModal_disclaimerModal__aU9LL","disclaimerBackdrop":"DisclaimerModal_disclaimerBackdrop__1TtF-"};